;(function($){

    function ExperimentalClass() {

        var _ =  this;

        var ExperimentalClassModal = new tingle.modal({
            footer: true,
            stickyFooter: false,
            closeLabel: "Close",
            cssClass: ['custom-class-1', 'custom-class-2'],
            closeMethods: ['button'],
            onClose: function() {
                ExperimentalClassModal.setContent('');
                ExperimentalClassModal.setFooterContent('');
            }
        }); 
        

        

        $(document).on('click', '.btn-experimental-class', function(e){
            e.preventDefault();

            var btnPlans = this;
            
            $(this).text("Carregando..."); 

            ExperimentalClassModal.addFooterBtn('Enviar', 'tingle-btn tingle-btn--pull-right tingle-btn--primary btn-experimental-class-send', function() {
            
                $("#form-experimental-class").submit();
            });

            ExperimentalClassModal.addFooterBtn('Fechar', 'tingle-btn tingle-btn--pull-right tingle-btn--danger', function() {
                ExperimentalClassModal.close();
            });

            var html = '<table style="margin-bottom: 0 !important;">' +
                '<thead>' +
                    '<tr>'+
                        '<th style="text-align: center !important; font-size: 1.5rem;">' +
                            'Solicite sua aula experimental'+
                        '</th>'+
                    '</tr>'+
                '</thead>'+
                '<tbody>'+
                    '<td>'+
                        '<form id="form-experimental-class">'+
                           '<div class="row">' +
                                '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<label for="name">Nome Completo</label>' +
                                        '<input type="text" id="name" name="name">' +
                                    '</div>'+
                                '</div>'+
                                 '<div class="col-lg-8  col-md-8  col-sm-8 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<label for="cpf">CPF</label>' +
                                        '<input type="text" id="cpf" name="cpf">' +
                                    '</div>'+
                                '</div>'+
                                '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<label for="birthday">Data de Aniversário</label>' +
                                        '<input type="date" id="birthday" name="birthday">' +
                                    '</div>'+
                                '</div>'+
                                '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<label for="phone">Telefone</label>' +
                                        '<input type="text" id="phone" name="phone">' +
                                    '</div>'+
                                '</div>'+ 
                                // '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                                //     '<div class="form-row">' +
                                //         '<label for="cellphone">Celular</label>' +
                                //         '<input type="text" id="cellphone" name="cellphone">' +
                                //     '</div>'+
                                // '</div>'+
                                 '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<label for="whatsapp">Whatsapp</label>' +
                                        '<input type="text" id="whatsapp" name="whatsapp">' +
                                    '</div>'+
                                '</div>'+
                                '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<label for="email">Email</label>' +
                                        '<input type="text" id="email" name="email">' +
                                    '</div>'+
                                '</div>'+  
                                '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<label for="office">Ocupação / Profissão</label>' +
                                        '<input type="text" id="office" name="office">' +
                                    '</div>'+
                                '</div>'+                             
                           '</div>'+
                            '<div class="row">' +
                                '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<input type="hidden" id="classes_id" name="classes_id" value="'+$(this).data('classe')+'">' +
                                    '</div>'+
                                '</div>'+                             
                           '</div>'+
                        '</form>'+
                    '</td>'+
                '</tbody>'+
            '</table>';

            ExperimentalClassModal.setContent(html);   
            $(document).find('[name=phone]').mask('(00) 0000-0000');
            $(document).find('[name=cellphone]').mask('(00) 00000-0000');  
            $(document).find('[name=cpf]').mask('999.999.999-99');       
            $(btnPlans).text("Aula Experimental");  

            _.myForm = $("#form-experimental-class").validate({
                rules: {
                    name: { required: true },
                    phone: { required: true },
                    //cellphone: { required: true},
                    email: { required: true },
                    office: { required: true }
                },
                messages: {
                    name: { required: "Campo Obrigatório" },
                    phone: { required: "Campo Obrigatório" },
                    //cellphone: { required: "Campo Obrigatório"},
                    email: { required: "Campo Obrigatório" },
                    office: { required: "Campo Obrigatório" }
                },
                submitHandler: function( form ) {
                    
                    $.ajax({
                        type: "POST",
                        url: $("#app_url").val() + "/api/aula-experimental",
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: new FormData(form),
                        success: function(result)
                        {
                           ExperimentalClassModal.setContent(" Seu pedido foi enviado com sucesso. Agora é só aguardar. Em breve, um professor credenciado conversará com você!");
                            $(".btn-experimental-class-send").remove();                                       
                        },
                        error: function(response) {
                            $(".btn-experimental-class-send").remove();
                           ExperimentalClassModal.setContent("Error ao enviar seu pedido, tente novamente mais tarde!");
                        }
                    });
                }
            });

           ExperimentalClassModal.open(); 
        });
    }

   	new ExperimentalClass();

}(jQuery));
 
 
 
 
